import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StammdatenService, Massnahme } from '@app/services/stammdaten.service';

export interface DialogData {
  mode: 'create' | 'edit';
  massnahme?: Massnahme;
}

@Component({
  selector: 'app-dialog-massnahme',
  templateUrl: './dialog-massnahme.component.html',
  styleUrls: ['./dialog-massnahme.component.css']
})
export class DialogMassnahmeComponent implements OnInit {
  massnahmeForm: FormGroup;
  isSubmitting = false;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogMassnahmeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private stammdatenService: StammdatenService,
    private snackBar: MatSnackBar
  ) {
    this.massnahmeForm = this.fb.group({
      beschreibung: ['', Validators.required],
      druck_auf_bericht: [false],
      foto_erforderlich: [false],
      sortierung: [0, Validators.required],
      status_id: [1, Validators.required],
      indikator_id: [0, Validators.required],
      freigeben: [false],
      fertig_setzen: [false]
    });
  }

  ngOnInit(): void {
    if (this.data.mode === 'edit' && this.data.massnahme) {
      this.populateForm(this.data.massnahme);
    }
  }

  populateForm(massnahme: Massnahme): void {
    this.massnahmeForm.patchValue({
      beschreibung: massnahme.beschreibung,
      druck_auf_bericht: massnahme.druck_auf_bericht === 1,
      foto_erforderlich: massnahme.foto_erforderlich === 1,
      sortierung: massnahme.sortierung,
      status_id: massnahme.status_id,
      indikator_id: massnahme.indikator_id,
      freigeben: massnahme.freigeben === 1,
      fertig_setzen: massnahme.fertig_setzen === 1
    });
  }

  onSubmit(): void {
    if (this.massnahmeForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      const formData = this.massnahmeForm.value;
      
      // Convert boolean values to integers
      const massnahmeData: Massnahme = {
        id: this.data.massnahme?.id || 0,
        beschreibung: formData.beschreibung,
        druck_auf_bericht: formData.druck_auf_bericht ? 1 : 0,
        foto_erforderlich: formData.foto_erforderlich ? 1 : 0,
        sortierung: formData.sortierung,
        status_id: formData.status_id,
        indikator_id: formData.indikator_id,
        freigeben: formData.freigeben ? 1 : 0,
        fertig_setzen: formData.fertig_setzen ? 1 : 0
      };

      if (this.data.mode === 'create') {
        this.stammdatenService.createMassnahme(massnahmeData).subscribe({
          next: (response) => {
            this.snackBar.open('Maßnahme erfolgreich erstellt', 'Schließen', { duration: 3000 });
            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('Error creating massnahme:', error);
            this.snackBar.open('Fehler beim Erstellen der Maßnahme', 'Schließen', { duration: 3000 });
            this.isSubmitting = false;
          }
        });
      } else {
        this.stammdatenService.updateMassnahme(massnahmeData.id, massnahmeData).subscribe({
          next: (response) => {
            this.snackBar.open('Maßnahme erfolgreich aktualisiert', 'Schließen', { duration: 3000 });
            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('Error updating massnahme:', error);
            this.snackBar.open('Fehler beim Aktualisieren der Maßnahme', 'Schließen', { duration: 3000 });
            this.isSubmitting = false;
          }
        });
      }
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
